import {
  GuestJourneySankeyResponse,
  GuestJourneyStageMovementCards,
  GuestJourneyStageMovementDataResponse,
} from '../guest-journey-reports.types';

// Values arrive pre-formatted from the BE; the frequency note rides on the
// card as `valueDescription`.
export const stageMovementCardsFixture: GuestJourneyStageMovementCards = {
  currentTotalMembers: {
    title: 'Current Total Members',
    value: '7,462',
    trend: { text: 'Moving Up', direction: 'UP_RIGHT' },
  },
  incomingMembers: {
    title: 'Incoming Members',
    value: '1,020',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  outgoingMembers: {
    title: 'Outgoing Members',
    value: '380',
    trend: { text: 'Trending Down', direction: 'DOWN', invertColor: true },
  },
  // Provided by the BE; not rendered yet (design shows 5 cards).
  netChange: {
    title: 'Net Change',
    value: '640',
  },
  frequencyMedianDays: {
    title: 'Frequency (Median Days)',
    value: '3',
    valueDescription: 'Median days between visits for this stage.',
  },
  totalSpendPerCustomer: {
    title: 'Total Spend / Customer',
    value: '$38.65',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
};

/**
 * Single movement payload (BE `PulseSankeyDTO`) — the sankey bands and the
 * Incoming/Outgoing tables both render from these flows. Movement is the full
 * `PulseMovementIndicator` (adopted in API v0.4, replacing the earlier spec's
 * bare `movementDirection` enum).
 */
export const stageMovementSankeyFixture: GuestJourneySankeyResponse = {
  stayedCount: 6082,
  incoming: [
    {
      stage: 'Value Explorer',
      count: 410,
      totalVisits: 19,
      totalSpendPerCustomer: 75.3,
      movement: { text: 'Moved Up', direction: 'UP_RIGHT' },
    },
    {
      stage: 'Value Regular',
      count: 230,
      totalVisits: 17,
      totalSpendPerCustomer: 68.9,
      movement: { text: 'Moved Up', direction: 'UP_RIGHT' },
    },
    {
      stage: 'Core Explorer',
      count: 160,
      totalVisits: 12,
      totalSpendPerCustomer: 46.4,
      movement: { text: 'Moved Up', direction: 'UP_RIGHT' },
    },
    {
      stage: 'Slider',
      count: 120,
      totalVisits: 8,
      totalSpendPerCustomer: 32.1,
      movement: { text: 'Moved Up', direction: 'UP_RIGHT' },
    },
    {
      stage: 'Indulgent Regular',
      count: 80,
      totalVisits: 22,
      totalSpendPerCustomer: 92.4,
      movement: { text: 'Moved Down', direction: 'DOWN_LEFT' },
    },
  ],
  outgoing: [
    {
      stage: 'Core Superfan',
      count: 140,
      totalVisits: 18,
      totalSpendPerCustomer: 72.1,
      movement: { text: 'Moved Up', direction: 'UP_RIGHT' },
    },
    {
      stage: 'Indulgent Regular',
      count: 90,
      totalVisits: 19,
      totalSpendPerCustomer: 78.4,
      movement: { text: 'Moved Up', direction: 'UP_RIGHT' },
    },
    {
      stage: 'Slider',
      count: 70,
      totalVisits: 15,
      totalSpendPerCustomer: 36.8,
      movement: { text: 'Moved Down', direction: 'DOWN_LEFT' },
    },
    {
      stage: 'Churned',
      count: 80,
      totalVisits: 0,
      totalSpendPerCustomer: 0,
      movement: { text: 'Moved Down', direction: 'DOWN_LEFT' },
    },
  ],
};

/** As served by `GET v2/guest-journey/stage-movement/data` (enveloped). */
export const stageMovementDataFixture: GuestJourneyStageMovementDataResponse = {
  sankey: stageMovementSankeyFixture,
};
